import React, { ReactElement, memo } from 'react'
import Gradient from '@sport1/react-elements/Gradient'
import Grid from '@sport1/react-elements/Grid'
import Touchable from '@sport1/react-elements/Touchable'
import { TestID } from '../../../utils/PropTypesDefinitions'
import Image from '../../../BaseComponents/Image'
import { ImageLabel } from '../../../BaseComponents/Image/Components'
import BasicText from '../../../Theme/Fonts/BasicText'
import { LabelProps } from '../../../BaseComponents/Labels/Types'
import LinkProps from '../../../Link/LinkProps'

export type TopImageProps = LabelProps & {
    /** imageProps must contain url */
    imageUrl?: string
    /** info for seo about imageUrl */
    alt?: string
    /** caption text under the teaser */
    caption?: string
    /** copyright info about image */
    copyright?: string
    /** max height for the image */
    maxHeight?: number
    /** href string to navigate to the provided url (web only) */
    href?: string
    /**
     * callback when the user pressed on the component
     *
     * @TJS-type function
     */
    onPress?: () => void
} & LinkProps &
    TestID

const TopImage = ({
    imageUrl,
    alt,
    labels,
    caption,
    copyright,
    maxHeight,
    href,
    onPress,
    testID,
    webRel,
}: TopImageProps): ReactElement => {
    return (
        <Touchable onPress={onPress} href={href} webRel={webRel}>
            <Grid noExpand position="relative" maxHeight={maxHeight} testID={testID}>
                <Image imageUrl={imageUrl} alt={alt} size="L" maxHeight={maxHeight} width="100%" />
                {labels ? <ImageLabel labels={labels} /> : null}
                {caption || copyright ? (
                    <Grid
                        zIndex={5}
                        position="absolute"
                        width="100%"
                        height="100%"
                        alignBottom
                        overflow="hidden"
                    >
                        <Gradient padding={16} alignBottom>
                            {caption ? (
                                <BasicText
                                    color="WHITE"
                                    fontSize={['FS12', 'FS12', 'FS14', 'FS16']}
                                    lineHeight={['LH16', 'LH16', 'LH18', 'LH20']}
                                    numberOfLines={0}
                                >
                                    {caption}
                                </BasicText>
                            ) : null}
                            {copyright ? (
                                <BasicText
                                    color="WHITE"
                                    fontSize={['FS12', 'FS12', 'FS14', 'FS16']}
                                    lineHeight={['LH16', 'LH16', 'LH18', 'LH20']}
                                    numberOfLines={0}
                                >
                                    {copyright}
                                </BasicText>
                            ) : null}
                        </Gradient>
                    </Grid>
                ) : null}
            </Grid>
        </Touchable>
    )
}

export default memo(TopImage)
